<template>
    <b-form-group>
        <label class="mb-1 text-lg d-flex align-items-center">
            Mô tả
        </label>
        <b-input v-model="entry.description" type="text" placeholder="Nhập mô tả..." />
    </b-form-group>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    data: () => ({
        entry: {
            description: "",
        },
    }),
    watch: {
        "entry.description": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    description: this.entry.description,
                });
            },
            deep: true,
        },
        "value.description": {
            handler: function () {
                this.entry.description = this.value.description;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
};
</script>